// @ts-nocheck

import styled from 'styled-components';

import TitleWithLine from '../TitleWithLine';

const Date = styled(TitleWithLine)`
  font-size: 1em;
  font-family: BettingPoliticaBold, sans-serif;
  margin-top: 0.4em;
`;

export default Date;
